import { C, FONTS } from '../../tokens/design';

export default function Tag({ label, color = C.t2 }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 8px', borderRadius: 4,
      fontSize: 11, fontWeight: 500, fontFamily: FONTS.mono,
      color, background: `${color}15`, border: `1px solid ${color}33`,
    }}>{label}</span>
  );
}
